import src from "IMAGE";
export default { src, width: 615, height: 185, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAP0lEQVR42iXJQQoAEBBAURehCItBClOEFXv3v42mWfz69YQuME2FFU9/poZN8cMiEzLappJDP/JVySPF75DsA5BHC8kNm1mrAAAAAElFTkSuQmCC"};
